import { atom, getDefaultStore } from 'jotai';

export type EventToast = {
  id: number;
  kind: 'join' | 'leave' | 'server' | 'warn';
  title: string;
  sub?: string;
  ts: number;
};

export const eventToastsAtom = atom<EventToast[]>([]);
const store = getDefaultStore();
let seq = 0;

export function pushEventToast(t: Omit<EventToast, 'id' | 'ts'>) {
  const id = ++seq;
  const toast: EventToast = { ...t, id, ts: Date.now() };
  store.set(eventToastsAtom, (prev) => [...prev.slice(-4), toast]);
  setTimeout(() => {
    store.set(eventToastsAtom, (prev) => prev.filter((x) => x.id !== id));
  }, 4500);
}
